// Single source of truth for "focus → route + label" mappings.
// Edit this file to add new focusable destinations later.
//
// Each entry can be referenced two ways:
//   1. Inbound URL  `?focus=KEY`  → useFocusScroll() will scroll/highlight any
//      element on the current page tagged with `data-focus="KEY"`.
//   2. Outbound CTA → use `ctaRoute(key)` helper below to render <Link>s that
//      send users to the right registration / enquiry flow with the right
//      analytics tag baked in.
//
// "kind" is informational only — used by Classes.jsx to route adult vs kids
// bento cards to the correct page.

export const CTA_ROUTES = {
  adult: {
    label: "Register for classes",
    to: "/adult-registration",
    focus: "adult",
    intent: "main",
    description: "Adult weekly classes & courses",
  },
  kids: {
    label: "Enrol your kid",
    to: "/kids-registration",
    focus: "kids",
    intent: "main",
    description: "Full kids registration",
  },
  taster: {
    label: "Book a £5 Kids Taster",
    to: "/kids-registration",
    focus: "kids",
    intent: "taster",
    description: "Paid £5 Kids Taster session",
  },
  youth: {
    label: "Join the Youth Theatre Company",
    to: "/youth-theatre",
    focus: "youth",
    intent: "main",
    description: "Youth Dance Theatre Company",
  },
  online: {
    label: "Join the waitlist",
    to: "/online",
    focus: "online",
    intent: "waitlist",
    description: "USDD+ courses",
  },
  battles: {
    label: "See upcoming battles",
    to: "/events",
    focus: "battles",
    intent: "register",
    description: "Events & battles",
  },
  schools: {
    label: "Request a quote",
    to: "/schools-organisations",
    focus: "schools",
    intent: "enquiry",
    description: "Schools & organisations",
  },
  merch: {
    label: "Shop merch",
    to: "/merch",
    focus: "merch",
    intent: "main",
    description: "Official USDD merch",
  },
  bookings: {
    label: "Book a class",
    to: "/schedule",
    focus: "bookings",
    intent: "main",
    description: "Live timetable (Acuity)",
  },
};

export function ctaRoute(key, extraParams = {}) {
  const r = CTA_ROUTES[key];
  if (!r) return { to: "/contact", label: "Contact us" };
  const params = new URLSearchParams();
  if (r.focus) params.set("focus", r.focus);
  if (r.intent) params.set("intent", r.intent);
  Object.entries(extraParams).forEach(([k, v]) => v && params.set(k, v));
  const qs = params.toString();
  return { ...r, to: qs ? `${r.to}?${qs}` : r.to };
}
